/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_File_UploadInputs */



/**
* | output |
* | --- |
* | "Cancel file upload" |
*
* @param {Cancel_File_UploadInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const cancel_file_upload = /** @type {((inputs?: Cancel_File_UploadInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_File_UploadInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Annuler le téléversement du fichier")
	if (locale === "de") return /** @type {LocalizedString} */ ("Datei-Upload abbrechen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Annulla caricamento file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Отменить загрузку файла")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cancelar la carga de archivos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("取消文件上传")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ファイルのアップロードをキャンセル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("फ़ाइल अपलोड रद्द करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Cancelar envio de arquivo")
	return /** @type {LocalizedString} */ ("Cancel file upload")
});